<template>
  <div class="fc-notice ask">
    <img src="../assets/img/question_icon.png" class="fc-icon-sm">
    <a :href="getH5Url()+'/recharge_faq/index.html'" class="fc-color-gray"
      target="_blank">{{ $t('m.rechargeFAQ_title') }}</a>
  </div>

  </template>
  <script>
export default {
  methods: {
    getH5Url() {
      let host = window.location.host
      if(host === process.env.buzzcast_host_ph) {
        return 'https://static.buzzcast.buzz'
      }
      return process.env.urlh5
    }
  }
}

  </script>
  <style scoped>
  .fc-notice.ask {
    padding-bottom: 1rem;
  }

  </style>



// WEBPACK FOOTER //
// src/components/ask.vue